import { IApiRequest } from '@/gateway/axios/IApiRequest'
import { sentbizApi } from '@/gateway/axios'
import { ChangePasswordParam } from '@/gateway/corpMember/model/ChangePasswordParam'

export interface ChangePassword extends IApiRequest {
  getInstance (): ChangePassword;
  request (data: ChangePasswordParam): Promise<any>;
}

export class ChangePassword implements ChangePassword {
  private static instance: ChangePassword
  private constructor () {}
  public static getInstance (): ChangePassword {
    if (!this.instance) this.instance = new ChangePassword()
    return this.instance
  }

  async request (data: ChangePasswordParam): Promise<any> {
    const requestOption: RequestOption = {
      url: 'corp-member/password',
      method: 'post',
      data
    }
    const response = await sentbizApi.request(requestOption)
    return response
  }
}
